import React from "react";
import { IoIosClose } from "react-icons/io";
import LoginSignUpForm from "../../../_components/_webapp/LoginSignUpForms/LoginSignUpForm";
import LoginSignUpOTPVerify from "../../../_components/_webapp/LoginSignUpForms/LoginSignUpOTPVerify";
import LoginKyc from "../../../_components/_webapp/LoginSignUpForms/LoginKyc";
import LoginEnterDetails from "../../../_components/_webapp/LoginSignUpForms/LoginEnterDetails";
import SelectBuySell from "../../../_components/_webapp/LoginSignUpForms/SelectBuySell";

import "./Login.css";
import { connect } from "react-redux";
import { UserDataActions } from "../../../_actions/userData.action";
import { withRouter } from "react-router";
import { optionActions } from "../../../_actions/option.actions";
import { MdKeyboardBackspace } from "react-icons/md";
import loginForm from "../../../assets/images/login.png";
import loginOTP from "../../../assets/images/otplogin.png";
import CompleteKYC from "../../../assets/images/Progress_Bar1.png";
import CompleteKYC2 from "../../../assets/images/Progress_Bar2.png";
import CompleteKYC3 from "../../../assets/images/Progress_Bar3.png";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import BankerRegistration from "../../../_components/_webapp/LoginSignUpForms/BankerRegistration/BankerRegistration";
import BrokerRegistration from "../../../_components/_webapp/LoginSignUpForms/BrokerRegistration";
import { getQueryParam, isMobileUser } from "../../../_helpers/Common/helper";
import {
  LOGIN_POPUP_APPEARING,
  LOGIN_POPUP_CLOSED,
} from "../../../_constants/Events/events";
import { EventTracker } from "../../../_helpers/Common/EventTrackingFunction";
class LoginPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formType: 1,
      contact_number: "",
      dataForSignUp: "",
      yourDetails: "",
      penError: "",
      aadhaarError: "",
      aadharError2: "",
      type: "",
      backOnType: "",
      isPending: "",
      bankReg: "",
      popupClosed: "",
    };
    this.myRef = React.createRef();
    this.popUpRef = React.createRef(false);
  }

  componentDidMount() {
    const addInfoForLoginClose =
      this.state.popupClosed === "invalid"
        ? "invalid_otp"
        : this.state.popupClosed === "after"
        ? "after_otp"
        : "before_otp";
    if (this.props.isShow) {
      EventTracker("event", LOGIN_POPUP_APPEARING, {
        event_category: "login_popup_appeared",
        event_action:
          this.props.location.pathname !== "/"
            ? this.props.location.pathname
            : "homepage",
        event_label: isMobileUser() ? "Mobile" : "Desktop",
      });
    }
    if (this.props.dataForSignUp) {
      if (this.props.dataForSignUp.mobile) {
        this.setState({
          formType: this.props.isSetBuySell ? 5 : 3,
          contact_number: this.props.dataForSignUp.mobile,
          dataForSignUp: this.props.dataForSignUp,
          isPending: true,
        });
      } else {
        this.props.close();
        EventTracker("event", LOGIN_POPUP_CLOSED, {
          event_category: "login_popup_closed",
          event_action:
            this.props.location.pathname !== "/"
              ? this.props.location.pathname
              : "homepage",
          event_label: isMobileUser() ? "Mobile" : "Desktop",
          addinfo: addInfoForLoginClose,
        });
      }
    }
  }

  componentDidUpdate(prev) {
    const addInfoForLoginClose =
      this.state.popupClosed === "invalid"
        ? "invalid_otp"
        : this.state.popupClosed === "after"
        ? "after_otp"
        : "before_otp";

    if (!this.popUpRef.current) {
      if (this.props.isShow) {
        EventTracker("event", LOGIN_POPUP_APPEARING, {
          event_category: "login_popup_appeared",
          event_action:
            this.props.location.pathname !== "/"
              ? this.props.location.pathname
              : "homepage",
          event_label: isMobileUser() ? "Mobile" : "Desktop",
        });
        this.popUpRef.current = true;
      }
    }
    if (
      this.props.dataForSignUp &&
      this.props.dataForSignUp !== prev.dataForSignUp
    ) {
      if (this.props.dataForSignUp.mobile) {
        this.setState({
          formType: this.props.isSetBuySell && this.state.bankReg == "" ? 5 : 3,
          contact_number: this.props.dataForSignUp.mobile,
          dataForSignUp: this.props.dataForSignUp,
          isPending: true,
        });
      } else {
        this.props.close();
        EventTracker("event", LOGIN_POPUP_CLOSED, {
          event_category: "login_popup_closed",
          event_action:
            this.props.location.pathname !== "/"
              ? this.props.location.pathname
              : "homepage",
          event_label: isMobileUser() ? "Mobile" : "Desktop",
          addinfo: addInfoForLoginClose,
        });
      }
    }

    if (this.props.isShow !== prev.isShow && !this.props.isShow) {
      this.setState({
        formType: 1,
      });
    }
  }

  changeFormType = (type, bankReg = "") => {
    if (this?.myRef?.current) this.myRef.current.scrollTo(0, 0);
    this.setState({
      formType: type,
      bankReg: bankReg
        ? bankReg
        : this.state.bankReg === "brokerSelected"
        ? "brokerSelected"
        : "",
    });
  };

  pageDetails = (details) => {
    this.myRef.current.scrollTo(0, 0);
    this.setState(
      {
        yourDetails: details,
      },
      () => {
        this.setState({
          formType: 4,
        });
      }
    );
  };

  onChangeType = (type) => {
    this.setState({
      type: type,
    });
  };

  onClickCloseBuySell = () => {
    const addInfoForLoginClose =
      this.state.popupClosed === "invalid"
        ? "invalid_otp"
        : this.state.popupClosed === "after"
        ? "after_otp"
        : "before_otp";
    localStorage.setItem("buysellcommodityLocationSaved", true);
    setTimeout(() => {
      this.props.close();
      EventTracker("event", LOGIN_POPUP_CLOSED, {
        event_category: "login_popup_closed",
        event_action:
          this.props.location.pathname !== "/"
            ? this.props.location.pathname
            : "homepage",
        event_label: isMobileUser() ? "Mobile" : "Desktop",
        addinfo: addInfoForLoginClose,
      });
    }, 100);
  };

  setPopupClosed = (closeValue) => {
    this.setState({
      popupClosed: closeValue,
    });
  };

  render() {
    return (
      <div
        className="popupWrapper"
        style={{ display: this.props.isShow ? "flex" : "none" }}
      >
        <div
          className={
            this.state.formType === 4 ? "newpopupBx poBX" : "popupBx poBX"
          }
          style={{
            margin: "5px",
            width:
              this.state.formType === 3 || this.state.formType === 4
                ? "480px"
                : "468px",
            height:
              this.state.formType === 1 || this.state.formType === 2
                ? "380px"
                : this.state.formType === 3
                ? "500px"
                : "550px",
          }}
        >
          {this.state.formType !== 5 &&
            (this.state.bankReg == "" ||
              this.state.bankReg == "brokerSelected") && (
              <div className="poheader">
                {
                  <>
                    {this.state.formType === 3 ? (
                      <>
                        {" "}
                        {this.state.type && (
                          <MdKeyboardBackspace
                            color={"#5c6b25"}
                            size="25"
                            onClick={() =>
                              this.setState({ backOnType: Math.random() })
                            }
                          ></MdKeyboardBackspace>
                        )}{" "}
                      </>
                    ) : this.state.formType === 4 ? (
                      <>
                        {" "}
                        <MdKeyboardBackspace
                          color={"#5c6b25"}
                          size="25"
                          onClick={() => this.setState({ formType: 3 })}
                        ></MdKeyboardBackspace>{" "}
                      </>
                    ) : null}

                    {this.state.formType === 1 ? (
                      <img src={loginForm} alt="" />
                    ) : this.state.formType === 2 ? (
                      <img src={loginOTP} alt="" />
                    ) : this.state.formType === 3 && !this.props.noKYC ? (
                      <>
                        {this.state.type ? (
                          <img src={CompleteKYC2} alt="" />
                        ) : (
                          <img src={CompleteKYC} alt="" />
                        )}{" "}
                      </>
                    ) : this.state.formType === 4 ? (
                      <img src={CompleteKYC3} alt="" />
                    ) : null}
                  </>
                }

                {this.state.formType !== 5 && (
                  <a
                    href="javascript:void(0)"
                    onClick={() => {
                      const addInfoForLoginClose =
                        this.state.popupClosed === "invalid"
                          ? "invalid_otp"
                          : this.state.popupClosed === "after"
                          ? "after_otp"
                          : "before_otp";
                      if (
                        this.props.isLAC &&
                        (this.state.formType === 1 || this.state.formType === 2)
                      )
                        this.props.close();
                      EventTracker("event", LOGIN_POPUP_CLOSED, {
                        event_category: "login_popup_closed",
                        event_action:
                          this.props.location.pathname !== "/"
                            ? this.props.location.pathname
                            : "homepage",
                        addinfo: addInfoForLoginClose,
                        event_label: isMobileUser() ? "Mobile" : "Desktop",
                      });
                    }}
                    className="closePopup loginclose"
                  >
                    <IoIosClose onClick={() => this.props.close()} />
                  </a>
                )}
                <h4>
                  {this.state.formType === 1 ? (
                    <MultiLanguageTranslation title="Login / Signup" />
                  ) : this.state.formType === 2 ? (
                    <MultiLanguageTranslation title="Verify OTP" />
                  ) : this.state.formType === 3 ? (
                    this.props.noKYC ? (
                      <MultiLanguageTranslation title="Select Your User Type" />
                    ) : (
                      <MultiLanguageTranslation title="Complete Your KYC" />
                    )
                  ) : this.state.formType === 4 ? (
                    <MultiLanguageTranslation title="Enter your details" />
                  ) :  null}
                </h4>
              </div>
            )}

          {this.state.formType === 5 && (
            <div className="poheader">
              <a href="javascript:void(0)" className="closePopup loginclose">
                <IoIosClose onClick={() => this.onClickCloseBuySell()} />
              </a>
            </div>
          )}

          <div className="popupBody poup" ref={this.myRef}>
            {this.state.formType === 1 ? (
              <LoginSignUpForm
                mbn={this.props.mbn}
                history={this.props.history}
                setPopupClosed={this.setPopupClosed}
                contact_number={this.state.contact_number}
                changeFormType={this.changeFormType}
                setContactNumber={(value) =>
                  this.setState({ contact_number: value })
                }
                isShow={this.props.isShow}
              ></LoginSignUpForm>
            ) : this.state.formType === 2 ? (
              <LoginSignUpOTPVerify
                {...this.props}
                setPopupClosed={this.setPopupClosed}
                contact_number={this.state.contact_number}
                changeFormType={this.changeFormType}
                dataForSignUp={(data) => this.setState({ dataForSignUp: data })}
                close={this.props.close}
                setWhatsappSubscribe={this.props.setWhatsappSubscribe}
              ></LoginSignUpOTPVerify>
            ) : this.state.formType === 3 && this.state.bankReg == "" ? (
              <LoginEnterDetails
                pageDetails={this.pageDetails}
                {...this.props}
                changeFormType={this.changeFormType}
                dataForSignUp={this.state.dataForSignUp}
                yourDetails={this.state.yourDetails}
                penError={this.state.penError}
                aadhaarError={this.state.aadhaarError}
                aadharError2={this.state.aadharError2}
                onChangeType={this.onChangeType}
                type={this.state.backOnType}
              ></LoginEnterDetails>
            ) : this.state.formType === 3 &&
              this.state.bankReg === "brokerSelected" ? (
              <BrokerRegistration
                pageDetails={this.pageDetails}
                {...this.props}
                changeFormType={this.changeFormType}
                dataForSignUp={this.state.dataForSignUp}
                yourDetails={this.state.yourDetails}
                penError={this.state.penError}
                aadhaarError={this.state.aadhaarError}
                aadharError2={this.state.aadharError2}
                onChangeType={this.onChangeType}
                type={this.state.backOnType}
              ></BrokerRegistration>
            ) : this.state.formType === 3 &&
              this.state.bankReg == "bankSelected" ? (
              <BankerRegistration
                {...this.props}
                contact_number={this.state.contact_number}
                changeFormType={this.changeFormType}
                dataForSignUp={this.state.dataForSignUp}
                yourDetails={this.state.yourDetails}
                close={this.props.close}
                isPending={this.state.isPending}
                onClickCloseBuySell={this.onClickCloseBuySell}
              />
            ) : this.state.formType === 4 ? (
              <LoginKyc
                {...this.props}
                contact_number={this.state.contact_number}
                changeFormType={this.changeFormType}
                dataForSignUp={this.state.dataForSignUp}
                yourDetails={this.state.yourDetails}
                close={this.props.close}
                setPANError={(e) => this.setState({ penError: e })}
                aadhaarError={(e, index) => {
                  if (index === 2) {
                    this.setState({ aadharError2: e, aadhaarError: "" });
                  } else {
                    this.setState({ aadhaarError: e, aadharError2: "" });
                  }
                }}
                isPending={this.state.isPending}
              ></LoginKyc>
            ) : this.state.formType === 5 ? (
              <>
                {this.props?.history?.location?.pathname.includes(
                  "/auction/"
                ) || getQueryParam("mobile") ? (
                  this.props.close()
                ) : (
                  <SelectBuySell
                    {...this.props}
                    contact_number={this.state.contact_number}
                    changeFormType={this.changeFormType}
                    dataForSignUp={this.state.dataForSignUp}
                    yourDetails={this.state.yourDetails}
                  ></SelectBuySell>
                )}
              </>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  add: optionActions.add,
  addCompareParameter: UserDataActions.addCompareParameter,
  addCartCount: UserDataActions.addCartCount,
  clearCartCount: UserDataActions.clearCartCount,
  clearCompare: UserDataActions.clearCompare,
  // filterData: optionActions.filters,
};

function mapStateToProps(state) {
  const { option } = state;
  return {
    option,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LoginPopup));
